import script from "./BCEvent.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCEvent.vue?vue&type=script&lang=ts&setup=true"

import "./BCEvent.vue?vue&type=style&index=0&id=2534c682&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2534c682"]])

export default __exports__